import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.SUPER_ADMIN };

const path = "admin/order";

export const OrderList = async (values) => {
    return await axiosInstance(options).post(`${path}/list`, values);
};
export const UpdateOrderStatus = async (values) => {
    return await axiosInstance(options).patch(`${path}/update-status`, values);
};
export const ManageReturn = async (values) => {
    return await axiosInstance(options).post(`${path}/manage-return`, values);
};
export const GetOrderDetails = async (id) => {
    return await axiosInstance(options).get(`${path}/details?order_id=${id}`);
};
export const DownloadInvoice = async (id) => {
    return await axiosInstance(options).get(`${path}/download-invoice/${id}`, {
        responseType: "blob",
    });
};
export const SendInvoiceEmail = async (orderId) => {
    return await axiosInstance(options).post(`${path}/send-invoice-email`, { order_id: orderId });
};

